module.exports = __webpack_public_path__ + "img/user-icon.6023a6a2.svg";